import Repository from "./Repository";

const resource = "/bo/pdf/generate";
export default {
  async get(project_uuid) {
    const { data } = await Repository.get(`${resource}/${project_uuid}`, {
      responseType: "arraybuffer"
    });
    return data;
  },

  async getProjectAndMedias(project_uuid) {
    const { data } = await Repository.get(
      `${resource}-with-media/${project_uuid}`,
      {
        responseType: "arraybuffer"
      }
    );
    return data;
  },

  async getMedias(project_uuid) {
    const { data } = await Repository.get(
      `${resource}-media-only/${project_uuid}`,
      {
        responseType: "arraybuffer"
      }
    );
    return data;
  },

  async getPlanning(params) {
    const { data } = await Repository.get(`${resource}-planning`, {
      responseType: "arraybuffer",
      params: params
    });
    return data;
  },

  /**
   * Editions
   */

  /**
   * Download InProgress PDF
   */
  async getInProgressPdf({ dateFrom, dateTo }) {
    const { data } = await Repository.get(`${resource}-export-in-progress`, {
      responseType: "arraybuffer",
      params: {
        date_start: dateFrom,
        date_end: dateTo
      }
    });
    return data;
  },

  /**
   * Download Accounting PDF
   */
  async getAccountingPdf(params) {
    return Repository.get(`${resource}-export-accounting`, {
      responseType: "arraybuffer",
      params
    });
  },

  /**
   * Download Workshop PDF
   */
  async getWorkshopPdf({ dateType, dateFrom, dateTo }) {
    const { data } = await Repository.get(`${resource}-export-workshop`, {
      responseType: "arraybuffer",
      params: {
        export_type: dateType,
        date_start: dateFrom,
        date_end: dateTo
      }
    });
    return data;
  },

  /**
   * Download Administration PDF
   */
  async getAdministrationPdf({ dateType, dateFrom, dateTo }) {
    const { data } = await Repository.get(`${resource}-export-administration`, {
      responseType: "arraybuffer",
      params: {
        export_type: dateType,
        date_start: dateFrom,
        date_end: dateTo
      }
    });
    return data;
  },

  /**
   * Download tour book PDF
   */
  async getTourBookPdf(date, applicators = []) {
    const applicatorsIds = applicators.join(",");

    const { data } = await Repository.get(`${resource}-export-tour-book`, {
      responseType: "arraybuffer",
      params: {
        date: date,
        applicators: applicatorsIds
      }
    });
    return data;
  },

  /**
   * Download notice
   */
  async getNoticePdf(project_uuid) {
    const { data } = await Repository.get(
      `${resource}/notice/${project_uuid}`,
      {
        responseType: "arraybuffer"
      }
    );
    return data;
  },

  /**
   * Download accouting excel
   */
  async getAccountingExcel(params) {
    return Repository.get("/bo/projects/editions/accounting/export", {
      responseType: "arraybuffer",
      params
    }).then(res => res.data);

    // const { data } = await Repository.get(
    //   `/bo/projects/editions/accounting/export`,
    //   {
    //     responseType: "arraybuffer",
    //     params: {
    //       date_start: dateFrom,
    //       date_end: dateTo
    //     }
    //   }
    // );
    // return data;
  },

  /**
   * Download in-progress excel
   */
  async getInProgressExcel({ dateFrom, dateTo }) {
    const { data } = await Repository.get(
      `/bo/projects/editions/in-progress/export`,
      {
        responseType: "arraybuffer",
        params: {
          date_start: dateFrom,
          date_end: dateTo
        }
      }
    );
    return data;
  },

  /**
   * Download accouting excel
   */
  async uploadQuotation(project_uuid, payload) {
    return Repository.post(`/bo/projects/${project_uuid}/invoice-pdf`, payload);
  }
};
